import type { EmbedSummary } from "./storefront-embed-summary";

export function StorefrontEmbedSummaryBar({
  summary,
  settledCount,
  totalShops,
}: {
  summary: EmbedSummary;
  settledCount: number;
  totalShops: number;
}) {
  const stats = [
    { label: "Actif", value: summary.active },
    { label: "Inactif", value: summary.inactive },
    { label: "Inconnu", value: summary.unknown },
    { label: "Avec script tag Baback", value: summary.withBabackScriptTag },
    { label: "Prêts à nettoyer", value: summary.readyToClean },
    { label: "Nettoyés", value: summary.cleaned },
    { label: "Erreurs", value: summary.errors },
  ];

  return (
    <div className="space-y-3 rounded-lg border bg-background p-4">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium">Embed actif</span>
        <div className="h-2 flex-1 rounded bg-muted">
          <div
            className="h-2 rounded bg-emerald-500"
            style={{ width: `${summary.activePercent}%` }}
          />
        </div>
        <span className="text-sm tabular-nums">{summary.activePercent} %</span>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
        {stats.map(({ label, value }) => (
          <span key={label} className="text-muted-foreground">
            {label} <strong className="text-foreground">{value}</strong>
          </span>
        ))}
      </div>
      {settledCount < totalShops && (
        <p className="text-xs text-muted-foreground">
          {settledCount} / {totalShops} shops chargés
        </p>
      )}
    </div>
  );
}
